define(['jquery', 'jquery.transit', 'modernizr', 'container', 'module-contact-content'],
    function ($, transit, modernizr, container, moduleContactContent) {

        return (function () {

            const name = 'contact';

            const model = container.getBaseModel(name);
            const view = container.getBaseView(name);
            //const pubSub = container.getPublishSubscribe();
            /* model */

            model.publicVars = {};

            model.privateVars = {};

            model.methods = {};

            /* view */

            view.publicVars = {};

            view.privateVars = {
                itemsKeys: [],
                items: new Map(),
                canNavigateAction: 0
            };

            view.startup = function () {

                if(view.publicVars.moduleContentConfig) {
                    view.privateVars.itemsKeys.push('contact-content');

                    view.privateVars.items.set('contact-content', {
                        init: false,
                        module: moduleContactContent,
                        config: view.publicVars.moduleContentConfig,
                        callbacks: {}
                    });
                }

                view.methods.handleCurrentScrollPosition();

                // moduleMediaCarousel.init(view.publicVars.moduleMediaCarouselConfig);
                // moduleVideoCarousel.init(view.publicVars.moduleVideoCarouselConfig);

            };

            view.bind = function () {
                $(window).scroll(function () {

                    let ticking = false;

                    if (view.privateVars.canNavigateAction === 0) {

                        if (!ticking) {
                            window.requestAnimationFrame(function () {
                                view.methods.handleCurrentScrollPosition();
                                ticking = false;
                            });
                        }
                        ticking = true;
                    }
                });

                $(window).resize(() => {
                    view.methods.handleCurrentScrollPosition();
                });

                $(window).on('orientationchange', () => {
                    view.methods.handleCurrentScrollPosition();
                });
            };

            view.methods = {
                handleCurrentScrollPosition: () => {

                    const systemCurrentScroll = $(document).scrollTop();

                    for (let [key, value] of view.privateVars.items) {

                        const targetPos = $(view.publicVars.cssId.layout.navigateTargetId + '-' + key).offset();

                        view.methods.handleModuleInit(systemCurrentScroll, key, targetPos);
                    }
                },

                handleModuleInit: (currentScroll, key, targetPos) => {

                    if (view.privateVars.items.get(key).module && view.privateVars.items.get(key).init === false) {
                        const rect = $(view.publicVars.cssId.layout.navigateTargetId + '-' + key)[0].getBoundingClientRect();
                        const scrollPlusWindowHeight = $(window).height() + currentScroll;

                        const specialModifier = $(view.publicVars.cssId.headerCls).outerHeight();

                        if ((targetPos.top - 200) < scrollPlusWindowHeight &&
                            (scrollPlusWindowHeight < (targetPos.top + rect.height) || currentScroll < (targetPos.top + rect.height + specialModifier))) {

                            view.methods.fireModuleStart(key);

                        }
                    }

                },

                fireModuleStart: (key) => {
                    if (view.privateVars.items.get(key).module && view.privateVars.items.get(key).init === false) {

                        view.privateVars.items.get(key).init = true;
                        view.privateVars.items.get(key).module.init(
                            view.privateVars.items.get(key).config,
                            view.privateVars.items.get(key).callbacks
                        );
                    }
                },
            };

            /* custom events */
            //pubSub.subscribe('view/actionShowFormThx', view.methods.actionShowFormThx);
            //pubSub.subscribe('view/showThx', view.methods.showThx);


            /* public methods */
            return {
                init: function (options) {
                    model.init(options);
                    view.init(options);
                }
            };


        })();


    });
